import { haversineDistance } from '../utils/haversine';

const RAIO_MAXIMO_METROS = 300;

/**
 * Encontra a empresa mais próxima dentro do raio permitido
 * @param {Array} empresas - Lista de empresas
 * @param {number} userLat - Latitude do usuário
 * @param {number} userLng - Longitude do usuário
 * @returns {Object|null} Empresa mais próxima ou null se nenhuma estiver no raio
 */
export function getNearestCompany(empresas, userLat, userLng) {
  if (!empresas || empresas.length === 0) {
    return null;
  }

  const empresasComDistancia = empresas
    .map((empresa) => {
      const distancia = haversineDistance(
        userLat,
        userLng,
        empresa.latitude || empresa.Latitude,
        empresa.longitude || empresa.Longitude
      );
      return {
        empresa,
        distancia
      };
    })
    .filter((item) => item.distancia <= RAIO_MAXIMO_METROS)
    .sort((a, b) => a.distancia - b.distancia);

  if (empresasComDistancia.length === 0) {
    return null;
  }

  // Retornar a empresa mais próxima
  return empresasComDistancia[0].empresa;
}

